import { render, staticRenderFns } from "./coursePersonnel.vue?vue&type=template&id=261bbe65&scoped=true"
import script from "./coursePersonnel.vue?vue&type=script&lang=js"
export * from "./coursePersonnel.vue?vue&type=script&lang=js"
import style0 from "./coursePersonnel.vue?vue&type=style&index=0&id=261bbe65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261bbe65",
  null
  
)

export default component.exports